import { cn } from "@/lib/utils";
import { responsiveImage } from "@/lib/responsive-image";

interface ImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

/**
 * Content image with a `srcSet` from `responsiveImage`: resized siblings for
 * app uploads, the `/img/<w>/...` resize route for other uploads (WordPress
 * import), nothing for external URLs. Pass `sizes` matching the rendered
 * width; the default fits a three-column grid.
 */
export function Img({ src, alt, className, sizes, ...props }: ImgProps) {
  const { src: resolvedSrc, srcSet } = responsiveImage(src);

  return (
    <img
      src={resolvedSrc}
      srcSet={srcSet}
      sizes={srcSet ? sizes || "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" : undefined}
      alt={alt}
      loading="lazy"
      decoding="async"
      className={cn(className)}
      {...props}
    />
  );
}
